import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { 
    TaiSan, 
    ChiTietTaiSan, 
    TaiSanRequest, 
    TimKiemTaiSanRequest, 
    ThongKeTaiSan, 
    TaiSanKiemKe, 
    ThongKeKiemKe, 
    BaoCaoKiemKe, 
    LuuKetQuaKiemKeRequest, 
    TimKiemTaiSanKiemKeRequest,
    DMCoSo,
    DMBopPhanKiemKe,
    DotKiemKeThanhVien,
    BangTongHopKiemKeBoPhan,
    BienBanTongHopKiemKeChiTiet
} from "../models/taisan/TaiSan";
import intance from "../utils/axios";

export const timKiemDSTaiSan = async (request: TimKiemTaiSanRequest, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.taiSan.timKiemDSTaiSan, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": request.tuKhoa || "",
            "idLoaiTaiSan": request.idLoaiTaiSan,
            "idCoSo": request.idCoSo,
            "idBoPhan": request.idBoPhan,
            "idDonVi": request.idDonVi,
            "trangThai": request.trangThai
        },
        "orderBy": {
            "columnName": "ngayKhoiTao",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layChiTietTaiSan = async (id: number) => {
    var rs: ChiTietTaiSan | null = null;
    await intance.get(ApiPaths.taiSan.layChiTiet + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuTaiSan = async (request: TaiSanRequest) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: 0 };
    const formData = new FormData();
    
    formData.append("id", (request.id || "").toString());
    formData.append("ma", request.ma || "");
    formData.append("maKeToan", request.maKeToan || "");
    formData.append("tenTaiSan", request.tenTaiSan || "");
    formData.append("idLoaiTaiSan", request.idLoaiTaiSan?.toString() || "");
    formData.append("idCoSo", request.idCoSo?.toString() || "");
    formData.append("idBoPhan", request.idBoPhan?.toString() || "");
    formData.append("idDonVi", request.idDonVi?.toString() || "");
    formData.append("idDonViQuanLy", request.idDonViQuanLy?.toString() || "");
    formData.append("idDonViSuDung", request.idDonViSuDung?.toString() || "");
    formData.append("idNVSuDung", request.idNVSuDung?.toString() || "");
    formData.append("viTriSuDung", request.viTriSuDung || "");
    formData.append("ngayTang", request.ngayTang || "");
    formData.append("ngayDuaVaoSuDung", request.ngayDuaVaoSuDung || "");
    formData.append("ngayNhapKho", request.ngayNhapKho || "");
    formData.append("soNamPhanBo", request.soNamPhanBo?.toString() ?? "");
    formData.append("soKyPhanBo", request.soKyPhanBo?.toString() ?? "");
    formData.append("soKyDaPhanBo", request.soKyDaPhanBo?.toString() ?? "");
    formData.append("giaTriKhiNhap", request.giaTriKhiNhap?.toString() || "");
    formData.append("nguyenGia", request.nguyenGia?.toString() || "");
    formData.append("giaTriDaPhanBo", request.giaTriDaPhanBo?.toString() || "");
    formData.append("giaTriConLai", request.giaTriConLai?.toString() || "");
    formData.append("trangThai", request.trangThai?.toString() || "0");
    formData.append("soSerial", request.soSerial || "");
    formData.append("nhaCungCap", request.nhaCungCap || "");
    formData.append("soLuong", request.soLuong?.toString() || "1");
    formData.append("thoiGianBaoHanh", request.thoiGianBaoHanh?.toString() || "");
    formData.append("moTa", request.moTa || "");
    formData.append("idTaiSanChinh", request.idTaiSanChinh?.toString() || "");

    request.files.forEach((file) => {
        formData.append("files", file);
    });
    
    if (request.idsTaiLieuTaiSanXoa) {
        request.idsTaiLieuTaiSanXoa.forEach((item) => {
            formData.append("idsTaiLieuTaiSanXoa", item.toString());
        });
    }

    await intance.post(ApiPaths.taiSan.luuTaiSan, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const xoaTaiSan = async (id: number) => {
    await intance.get(ApiPaths.taiSan.xoaTaiSan + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                // Success
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const thongKeTaiSan = async (idDonVi?: number) => {
    var rs: ThongKeTaiSan = {
        tongTaiSan: 0,
        dangSuDung: 0,
        tamDungSuDung: 0,
        suaChua: 0,
        baoTri: 0,
        dieuChuyen: 0,
        choThanhLy: 0,
        tongGiaTri: 0
    };
    
    const url = idDonVi 
        ? `${ApiPaths.taiSan.thongKeTaiSan}?idDonVi=${idDonVi}`
        : ApiPaths.taiSan.thongKeTaiSan;
        
    await intance.get(url)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layTaiSanTheoMaQR = async (maQR: string) => {
    var rs: TaiSan | null = null;
    await intance.get(ApiPaths.taiSan.layTaiSanTheoMaQR + "?maQR=" + encodeURIComponent(maQR))
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const sinhMaQR = async (idTaiSan: number) => {
    var maQR = "";
    await intance.get(ApiPaths.taiSan.sinhMaQR + "?idTaiSan=" + idTaiSan)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                maQR = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return maQR;
};

export const capNhatTrangThaiTaiSan = async (idTaiSan: number, trangThai: number, lyDo: string) => {
    await intance.post(ApiPaths.taiSan.capNhatTrangThai, {
        idTaiSan,
        trangThai,
        lyDo
    })
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDsTaiSanInQR = async (idsTaiSan: number[]) => {
    var rs: TaiSan[] = [];
    await intance.post(ApiPaths.taiSan.layDsTaiSanInQR, { idsTaiSan })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDsTaiSanInQRToanBo = async (request: TimKiemTaiSanRequest) => {
    var rs: TaiSan[] = [];
    await intance.post(ApiPaths.taiSan.layDsTaiSanInQRToanBo, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const xuatExcelDanhSachTaiSan = async (request: TimKiemTaiSanRequest, phanLoai: 'TSCD' | 'CCDC') => {
    const response = await intance.post(
        `${ApiPaths.taiSan.xuatExcelDanhSachTaiSan}?phanLoai=${phanLoai}`,
        {
            tuKhoa: request.tuKhoa || "",
            idLoaiTaiSan: request.idLoaiTaiSan,
            idCoSo: request.idCoSo,
            idBoPhan: request.idBoPhan,
            idDonVi: request.idDonVi,
            trangThai: request.trangThai
        },
        { responseType: 'blob' }
    );
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = phanLoai === 'CCDC' ? 'danh-sach-cong-cu-dung-cu.xlsx' : 'danh-sach-tai-san-co-dinh.xlsx';
    link.click();
    window.URL.revokeObjectURL(link.href);
};

export const layDsTaiSanKiemKe = async (request: TimKiemTaiSanKiemKeRequest, start: number, length: number) => {
    var data = {
        data: [] as TaiSanKiemKe[],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.taiSan.layDsTaiSanKiemKe, {
        "start": start,
        "length": length,
        "filter": request,
        "orderBy": {
            "columnName": "maChinh",
            "isDesc": false
        }
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuKetQuaKiemKe = async (request: LuuKetQuaKiemKeRequest) => {
    var response = { trangThai: responseStatus.loi, thongBao: "" };
    await intance.post(ApiPaths.taiSan.luuKetQuaKiemKe, request)
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const thongKeKiemKe = async (idDotKiemKe: number) => {
    var rs: ThongKeKiemKe = {
        tongTaiSan: 0,
        daKiemKe: 0,
        chuaKiemKe: 0,
        dangSuDung: 0,
        khongSuDung: 0
    };
    await intance.get(ApiPaths.taiSan.thongKeKiemKe + "?idDotKiemKe=" + idDotKiemKe)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layBaoCaoKiemKe = async (idDotKiemKe: number, idDotKiemKeTruoc?: number) => {
    var rs: BaoCaoKiemKe[] = [];
    let url = ApiPaths.taiSan.layBaoCaoKiemKe + "?idDotKiemKe=" + idDotKiemKe;
    if (idDotKiemKeTruoc) url += "&idDotKiemKeTruoc=" + idDotKiemKeTruoc;
    await intance.get(url)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const xuatBaoCaoKiemKe = async (idDotKiemKe: number, idDotKiemKeTruoc?: number) => {
    let url = ApiPaths.taiSan.xuatBaoCaoKiemKe + "?idDotKiemKe=" + idDotKiemKe;
    if (idDotKiemKeTruoc) url += "&idDotKiemKeTruoc=" + idDotKiemKeTruoc;
    const response = await intance.get(url, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'bao-cao-kiem-ke-tai-san.xlsx';
    link.click();
    window.URL.revokeObjectURL(link.href);
};

export const themTaiSanPhu = async (idTaiSanPhu: number, idTaiSanChinh: number) => {
    let rs: any = null;
    await intance.post(ApiPaths.taiSan.themTaiSanPhu + "?idTaiSanPhu=" + idTaiSanPhu + "&idTaiSanChinh=" + idTaiSanChinh, {})
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const xoaTaiSanPhu = async (idTaiSanPhu: number) => {
    let rs: any = null;
    await intance.post(ApiPaths.taiSan.xoaTaiSanPhu + "?idTaiSanPhu=" + idTaiSanPhu, {})
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDsTaiSanPhu = async (idTaiSanChinh: number) => {
    let rs: TaiSan[] = [];
    await intance.get(ApiPaths.taiSan.layDsTaiSanPhu + "?idTaiSanChinh=" + idTaiSanChinh)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

// Biểu mẫu 1: Bảng tổng hợp kiểm kê TSCĐ, CCDC của các phòng/ban
export const layBangTongHopKiemKeBoPhan = async (idDotKiemKe: number) => {
    var rs: BangTongHopKiemKeBoPhan[] = [];
    await intance.get(ApiPaths.taiSan.layBangTongHopKiemKeBoPhan + "?idDotKiemKe=" + idDotKiemKe)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const xuatExcelBangTongHopKiemKeBoPhan = async (idDotKiemKe: number) => {
    const response = await intance.get(ApiPaths.taiSan.xuatExcelBangTongHopKiemKeBoPhan + "?idDotKiemKe=" + idDotKiemKe, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'bang-tong-hop-kiem-ke-phong-ban.xlsx';
    link.click();
    window.URL.revokeObjectURL(link.href);
};

// Biểu mẫu 2 & 3: Biên bản tổng hợp kết quả kiểm kê TSCĐ / CCDC
export const layBienBanTongHopKiemKe = async (idDotKiemKe: number, phanLoai: string) => {
    var rs: any = null;
    await intance.get(`${ApiPaths.taiSan.layBienBanTongHopKiemKe}?idDotKiemKe=${idDotKiemKe}&phanLoai=${encodeURIComponent(phanLoai)}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const xuatExcelBienBanTongHopKiemKe = async (idDotKiemKe: number, phanLoai: string) => {
    const response = await intance.get(`${ApiPaths.taiSan.xuatExcelBienBanTongHopKiemKe}?idDotKiemKe=${idDotKiemKe}&phanLoai=${encodeURIComponent(phanLoai)}`, { responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    const fileName = phanLoai === 'CCDC' ? 'bien-ban-kiem-ke-ccdc.xlsx' : 'bien-ban-kiem-ke-tscd.xlsx';
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
};

// Danh mục Cơ sở & Bộ phận kiểm kê
export const layDsCoSo = async () => {
    var rs: DMCoSo[] = [];
    await intance.get(ApiPaths.taiSan.layDsCoSo)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuDMCoSo = async (model: Partial<DMCoSo>) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: 0 };
    await intance.post(ApiPaths.taiSan.luuDMCoSo, model)
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const xoaDMCoSo = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.get(`${ApiPaths.taiSan.xoaDMCoSo}?id=${id}`)
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const layDsBoPhanKiemKe = async () => {
    var rs: DMBopPhanKiemKe[] = [];
    await intance.get(ApiPaths.taiSan.layDsBoPhanKiemKe)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuDMBopPhanKiemKe = async (model: Partial<DMBopPhanKiemKe>) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: 0 };
    await intance.post(ApiPaths.taiSan.luuDMBopPhanKiemKe, model)
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const xoaDMBopPhanKiemKe = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.get(`${ApiPaths.taiSan.xoaDMBopPhanKiemKe}?id=${id}`)
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const layDsThanhVienKiemKe = async (idDotKiemKe: number) => {
    var rs: DotKiemKeThanhVien[] = [];
    await intance.get(ApiPaths.taiSan.layDsThanhVienKiemKe + "?idDotKiemKe=" + idDotKiemKe)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuDsThanhVienKiemKe = async (request: { idDotKiemKe: number; dsThanhVien: DotKiemKeThanhVien[] }) => {
    var response = { trangThai: responseStatus.loi, thongBao: "" };
    await intance.post(ApiPaths.taiSan.luuDsThanhVienKiemKe, request)
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};
